// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchIcon__icon___N84Qs","transform":"SearchIcon__transform___3irhw"};